import React from 'react'
import { CButton, CModal, CModalBody, CModalHeader, CModalTitle, CModalFooter } from '@coreui/react';
import { DatePicker, Flex, Input, message, Select, Typography } from 'antd';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { useState } from 'react';
import { addAbonement, getAbonementsClient, commentsAction, getCode } from 'src/store/Slices/ClientsSlice';
import { openNotification } from 'src/components/helpers/notification';
import { useEffect } from 'react';
import { getClientsList } from 'src/store/Slices/ClientsSlice';




const CodeModal = ({ codeModal, setCodeModal, clientInfo }) => {
    
    const dispatch = useDispatch()
    const code = useSelector(state => state.ClientsSlice.code?.data?.value?.value)

    useEffect(() => {
        if (codeModal)
        dispatch(getCode({id: clientInfo?.id}))
    }, [codeModal])

    return (
        <CModal
            alignment="center"
            visible={codeModal}
            aria-labelledby="VerticallyCenteredExample"
            onClose={() => { setCodeModal(false) }}
            keyboard={true}
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredExample">{
                    'Код'
                }</CModalTitle>
            </CModalHeader>
            <CModalBody style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <Flex vertical>
                    <>
                        <div>
                            {code}
                        </div>
                    </>
                </Flex>

            </CModalBody>
            <CModalFooter>
                <CButton
                    onClick={() => { setCodeModal(false) }}
                    style={{ color: '#fff' }}
                >
                    Ок
                </CButton>
                {/* <CButton onClick={onClickSetFilter} style={{ color: '#fff' }}>
                    Установить фильтр
                </CButton> */}
            </CModalFooter>
        </CModal>
    )
}

export default CodeModal